// *******************************************************************************
// Mobile menu toggle
// *******************************************************************************

const toggleMenuClass = (toggle) => {
  document.body.classList.toggle('is-open-menu', toggle);
};

attachEvent('.hamburger', 'click', (ev) => {
  ev.preventDefault();
  const isOpen = document.body.classList.contains('is-open-menu');
  toggleMenuClass(!isOpen);
});

// *******************************************************************************
// Add class to body after some scroll
// *******************************************************************************
function addScrollingClass() {
  const topOffset = document.documentElement.scrollTop || document.body.scrollTop;
  document.body.classList.toggle('is-scrolled', topOffset > 200);
}

addScrollingClass();

let ticking = false;
document.addEventListener('scroll', () => {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      addScrollingClass();
      ticking = false;
    });
    ticking = true;
  }
});

let lastScrollTop = 0;
window.addEventListener(
  'scroll',
  () => {
    const isScrolledTop = window.pageYOffset || document.documentElement.scrollTop;
    document.body.classList.toggle('is-scrolled-up', isScrolledTop < lastScrollTop);
    lastScrollTop = isScrolledTop <= 0 ? 0 : isScrolledTop;
  },
  false,
);

// *******************************************************************************
// Remove sticky header
// *******************************************************************************

const removeStickyHeader = document.querySelectorAll('.remove-sticky-header');
const headerElem = document.querySelector('.site-header');

if (removeStickyHeader && headerElem) {
  const headerHeight = headerElem.offsetHeight / 2;
  const headerController = new ScrollMagic.Controller();

  const headerScrollObserver = () => {
    removeStickyHeader.forEach((el) => {
      new ScrollMagic.Scene({ triggerElement: el, duration: el.offsetHeight })
        .setClassToggle('.site-header', 'hide-header') // add class toggle
        .offset(-headerHeight) // Offset calcs the header height (half of it)
        .triggerHook(0) // 0 = Top, 1 = bottom
        // .addIndicators({ name: 'hide header' })
        .addTo(headerController);
    });

    if (windowWidth() > breakpointMd) {
      headerController.enabled(true);
    } else {
      headerController.enabled(false);
      headerElem.classList.remove('hide-header');
    }

    headerController.update(true); // We need to update the controller after enabling/disabling it!
  };

  window.addEventListener('DOMContentLoaded', headerScrollObserver);
}

// *******************************************************************************
// Add/Remove class when page at top/bottom
// *******************************************************************************
// Function to add the class when at the top
const addClassAtTop = () => {
  document.body.classList.toggle('page-at-top', window.scrollY === 0);
};

// Function to add the class when at the bottom
const addClassAtBottom = () => {
  const windowHeight = window.innerHeight;
  const documentHeight = document.documentElement.scrollHeight;
  document.body.classList.toggle('page-at-bottom', window.scrollY + windowHeight >= documentHeight);
};

addClassAtTop();
addClassAtBottom();

// Attach event listeners to the window
window.addEventListener('scroll', addClassAtTop);
window.addEventListener('scroll', addClassAtBottom);

if (!headerElem) {
  document.body.classList.add('without-header');
}

// **************************************************
// Add content ID to first element after breadcrumbs
// **************************************************

window.addEventListener('DOMContentLoaded', () => {
  const mainDiv = document.querySelector('main');
  if (mainDiv) {
    const item = document.querySelector('main > *:first-of-type');

    item.setAttribute('id', 'content');
    item.setAttribute('tabIndex', '1');
  }

  const siteHeader = document.querySelector('.header-main');
  const wcagBtn = document.querySelector('#pojo-a11y-toolbar');
  if (siteHeader) {
    setTimeout(() => {
      document.body.append(siteHeader);
    }, 100);
  }
  if (wcagBtn) {
    setTimeout(() => {
      document.body.append(wcagBtn);
    }, 200);
  }
});
